module.exports = __webpack_public_path__ + "static/media/incoming-call.8d466b75.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/incoming-call.svg
// module id = 628
// module chunks = 0